var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 16.6663L13.0935 13.0825M13.0935 13.0825C12.0591 14.1198 10.6282 14.7616 9.04754 14.7616C5.89162 14.7616 3.33325 12.2032 3.33325 9.04729C3.33325 5.89138 5.89162 3.33301 9.04754 3.33301C12.2034 3.33301 14.7618 5.89138 14.7618 9.04729C14.7618 10.6225 14.1245 12.0489 13.0935 13.0825Z",
    stroke: "#1B202C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.714053fa6bd9acacef4711b5c2758fca.svg";
export { ForwardRef as ReactComponent };